import axios from 'axios'

const getBasvuruByNo = async (basvuruNo = null) => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/basvuru/'+basvuruNo,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    };
    await axios(config)
        .then((res) => {
            response = res.data;
        })
        .catch((err) => {
            response = false
        });
    return response;
};

export default getBasvuruByNo;